import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '../api';

const PREFIX = '+90';

function normalizePhone(val) {
  if (!val) return '';
  if (val.startsWith(PREFIX)) return val;
  const digits = val.replace(/\D/g, '').replace(/^0/, '');
  return digits ? PREFIX + digits : '';
}

function PhoneInput({ value, onChange, placeholder = '5XX XXX XX XX' }) {
  const raw = value.startsWith(PREFIX) ? value.slice(PREFIX.length) : value.replace(/\D/g, '');
  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
    onChange(digits ? PREFIX + digits : '');
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{
        background: '#f0f4ff', border: '1px solid #c5cae9', borderRight: 'none',
        padding: '8px 10px', borderRadius: '4px 0 0 4px', color: '#3949ab',
        fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap', lineHeight: '1.4'
      }}>{PREFIX}</span>
      <input
        type="tel" value={raw} onChange={handleChange}
        placeholder={placeholder} maxLength={10}
        style={{ borderRadius: '0 4px 4px 0', flex: 1 }}
      />
    </div>
  );
}

function MultiTelefonlar({ value, onChange }) {
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  const update = (i, field, v) => {
    const next = [...value];
    next[i] = { ...next[i], [field]: v };
    onChange(next);
  };
  return (
    <div>
      {value.map((t, i) => (
        <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: '6px', alignItems: 'center' }}>
          <select value={t.tip} onChange={e => update(i, 'tip', e.target.value)}
            style={{ width: '90px', flexShrink: 0 }}>
            <option value="cep">Cep</option>
            <option value="is">İş</option>
            <option value="ev">Ev</option>
            <option value="faks">Faks</option>
            <option value="diger">Diğer</option>
          </select>
          <div style={{ flex: 1 }}>
            <PhoneInput value={t.telefon} onChange={v => update(i, 'telefon', v)} />
          </div>
          <button type="button" onClick={() => remove(i)}
            style={{ background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '4px',
              padding: '6px 10px', cursor: 'pointer', color: '#c62828', flexShrink: 0 }}>✕</button>
        </div>
      ))}
    </div>
  );
}

function MultiEmailler({ value, onChange }) {
  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  const update = (i, v) => {
    const next = [...value];
    next[i] = { ...next[i], email: v };
    onChange(next);
  };
  return (
    <div>
      {value.map((e, i) => (
        <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: '6px', alignItems: 'center' }}>
          <input type="email" value={e.email} onChange={ev => update(i, ev.target.value)}
            placeholder="ornek@mail.com" style={{ flex: 1 }} />
          <button type="button" onClick={() => remove(i)}
            style={{ background: '#ffebee', border: '1px solid #ef9a9a', borderRadius: '4px',
              padding: '6px 10px', cursor: 'pointer', color: '#c62828', flexShrink: 0 }}>✕</button>
        </div>
      ))}
    </div>
  );
}

function MilliyetSecici({ value, onChange, milliyetler, onYeni, onDuzenle }) {
  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
      <select value={value} onChange={e => onChange(e.target.value)} style={{ flex: 1 }}>
        <option value="">Seçin...</option>
        {milliyetler.map(m => <option key={m.id} value={m.id}>{m.adi}</option>)}
      </select>
      <button type="button" onClick={onYeni}
        title="Yeni milliyet ekle"
        style={{ background: '#e3f2fd', border: '1px solid #90caf9', borderRadius: '4px',
          padding: '6px 10px', cursor: 'pointer', color: '#1565c0', fontWeight: 'bold', flexShrink: 0 }}>+</button>
      {value && (
        <button type="button" onClick={() => onDuzenle(value)}
          title="Seçili milliyeti düzenle"
          style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '4px',
            padding: '6px 10px', cursor: 'pointer', color: '#f57f17', flexShrink: 0 }}>✎</button>
      )}
    </div>
  );
}

export default function SicilForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const duzenleme = !!id;
  const ruhsataDon = searchParams.get('ruhsataDon') === '1';

  const [form, setForm] = useState({
    sicil_tipi: 'GERCEK', tcno: '', vn: '', vd: '', adi: '', soyadi: '',
    unvani: '', babadi: '', anadi: '', dogum_yeri: '', dogum_tarihi: '',
    sirket_tipi_id: '', tc_sicil_no: '',
    telefon: '', cep_telefonu: '', email: '',
    cinsiyet: '', milliyet_id: '1', egitim_durumu: '', kan_grubu: '',
  });
  const [telefonlar, setTelefonlar] = useState([]);
  const [emailler, setEmailler] = useState([]);
  const [yetkililer, setYetkililer] = useState([]); // [{tcno,adi,soyadi,babadi,anadi,dogum_tarihi,dogum_yeri,gorevi}]
  const [yetkiliModal, setYetkiliModal] = useState(null); // null | {idx, tcno,adi,soyadi,babadi,anadi,dogum_tarihi,dogum_yeri,gorevi}
  const [sirketTipleri, setSirketTipleri] = useState([]);
  const [milliyetler, setMilliyetler] = useState([]);
  const [hata, setHata] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [milliyetModal, setMilliyetModal] = useState(null); // null | { id?, adi }
  const [sirketTipiModal, setSirketTipiModal] = useState(false);
  const [yeniSirketTipi, setYeniSirketTipi] = useState('');

  const loadMilliyetler = () => api.get('/sicil/milliyet').then(r => setMilliyetler(r.data));

  useEffect(() => {
    api.get('/tanimlar/sirket-tipleri').then(r => setSirketTipleri(r.data));
    loadMilliyetler();
    if (duzenleme) {
      api.get(`/sicil/${id}`).then(r => {
        const d = r.data;
        setForm({
          sicil_tipi: d.sicil_tipi || 'GERCEK', tcno: d.tcno || '', vn: d.vn || '', vd: d.vd || '',
          adi: d.adi || '', soyadi: d.soyadi || '', unvani: d.unvani || '',
          babadi: d.babadi || '', anadi: d.anadi || '', dogum_yeri: d.dogum_yeri || '',
          dogum_tarihi: d.dogum_tarihi ? d.dogum_tarihi.split('T')[0] : '',
          sirket_tipi_id: d.sirket_tipi_id || '', tc_sicil_no: d.tc_sicil_no || '',
          telefon: normalizePhone(d.telefon), cep_telefonu: normalizePhone(d.cep_telefonu),
          email: d.email || '',
          cinsiyet: d.cinsiyet || '',
          milliyet_id: d.milliyet_id || '1',
          egitim_durumu: d.egitim_durumu || '', kan_grubu: d.kan_grubu || '',
        });
        setTelefonlar((d.telefonlar || []).map(t => ({ ...t, telefon: normalizePhone(t.telefon) })));
        setEmailler(d.emailler || []);
        setYetkililer(d.yetkililer || []);
      });
    }
  }, [id, duzenleme]);

  const f = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleVnChange = (e) => {
    setForm({ ...form, vn: e.target.value.replace(/\D/g, '').slice(0, 10) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');

    const tcDigits = form.tcno.replace(/\D/g, '');
    if (form.tcno && tcDigits.length !== 11) return setHata('T.C. Kimlik No 11 haneli olmalıdır.');
    if (form.vn && form.vn.length !== 10) return setHata('Vergi numarası 10 haneli olmalıdır.');

    const telDigits = form.telefon ? form.telefon.replace(/\D/g, '') : '';
    if (form.telefon && telDigits.length !== 12) return setHata('Telefon numarası 10 haneli olmalıdır (+90 hariç).');
    const cepDigits = form.cep_telefonu ? form.cep_telefonu.replace(/\D/g, '') : '';
    if (form.cep_telefonu && cepDigits.length !== 12) return setHata('Cep telefonu 10 haneli olmalıdır (+90 hariç).');

    for (const t of telefonlar) {
      if (t.telefon) {
        const d = t.telefon.replace(/\D/g, '');
        if (d.length !== 12) return setHata('Tüm ek telefon numaraları 10 haneli olmalıdır (+90 hariç).');
      }
    }

    setKaydediliyor(true);
    try {
      const payload = { ...form, telefonlar, emailler, yetkililer };
      if (duzenleme) {
        await api.put(`/sicil/${id}`, payload);
        if (ruhsataDon && window.opener) {
          window.opener.postMessage({ type: 'SICIL_GUNCELLENDI', sicilId: Number(id) }, window.location.origin);
          window.close();
          return;
        }
        navigate('/sicil');
      } else {
        await api.post('/sicil', payload);
        navigate('/sicil');
      }
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kayıt hatası');
    } finally { setKaydediliyor(false); }
  };

  const milliyetKaydet = async () => {
    if (!milliyetModal?.adi?.trim()) return;
    try {
      if (milliyetModal.id) {
        await api.put(`/sicil/milliyet/${milliyetModal.id}`, { adi: milliyetModal.adi });
      } else {
        const r = await api.post('/sicil/milliyet', { adi: milliyetModal.adi });
        setForm(f => ({ ...f, milliyet_id: r.data.id }));
      }
      await loadMilliyetler();
      setMilliyetModal(null);
    } catch (err) {
      alert(err.response?.data?.hata || 'Hata');
    }
  };

  const sirketTipiKaydet = async () => {
    if (!yeniSirketTipi.trim()) return;
    try {
      const r = await api.post('/tanimlar/sirket-tipleri', { tip_adi: yeniSirketTipi.trim() });
      setSirketTipleri(prev => [...prev, r.data].sort((a, b) => a.tip_adi.localeCompare(b.tip_adi, 'tr')));
      setForm(prev => ({ ...prev, sirket_tipi_id: r.data.id }));
      setYeniSirketTipi('');
      setSirketTipiModal(false);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Şirket tipi eklenemedi.');
    }
  };

  const tuzel = form.sicil_tipi === 'TUZEL' || form.sicil_tipi === 'KAMU';

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)} style={{ marginBottom: '8px' }}>← Geri</button>
        <h2 style={{ color: '#1a237e' }}>{duzenleme ? '✏️ Sicil Düzenle' : '👤 Yeni Sicil Kaydı'}</h2>
      </div>
      {hata && <div className="alert alert-error">{hata}</div>}

      {/* Milliyet Modal */}
      {milliyetModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{ background: '#fff', borderRadius: '8px', padding: '24px', width: '360px', boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
            <h3 style={{ marginBottom: '16px', color: '#1a237e' }}>
              {milliyetModal.id ? 'Milliyet Düzenle' : 'Yeni Milliyet'}
            </h3>
            <input
              autoFocus
              value={milliyetModal.adi}
              onChange={e => setMilliyetModal({ ...milliyetModal, adi: e.target.value })}
              placeholder="Milliyet adı"
              style={{ width: '100%', marginBottom: '16px' }}
              onKeyDown={e => e.key === 'Enter' && milliyetKaydet()}
            />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button className="btn btn-secondary" onClick={() => setMilliyetModal(null)}>İptal</button>
              <button className="btn btn-primary" onClick={milliyetKaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {sirketTipiModal && (
        <div className="form-modal-backdrop" role="presentation" onMouseDown={() => setSirketTipiModal(false)}>
          <div className="form-modal" role="dialog" aria-modal="true" aria-labelledby="sirket-tipi-baslik" onMouseDown={e => e.stopPropagation()}>
            <h3 id="sirket-tipi-baslik">Yeni şirket tipi</h3>
            <div className="form-group">
              <label>Şirket tipi adı</label>
              <input autoFocus value={yeniSirketTipi} onChange={e => setYeniSirketTipi(e.target.value)} onKeyDown={e => e.key === 'Enter' && sirketTipiKaydet()} />
            </div>
            <div className="form-modal-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setSirketTipiModal(false)}>İptal</button>
              <button type="button" className="btn btn-primary" onClick={sirketTipiKaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* Yetkili Kişi Modal */}
      {yetkiliModal !== null && (
        <div className="form-modal-backdrop" role="presentation" onMouseDown={() => setYetkiliModal(null)}>
          <div className="form-modal" role="dialog" aria-modal="true" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: '520px' }}>
            <h3 style={{ marginBottom: '16px', color: '#1a237e' }}>
              {yetkiliModal.idx === -1 ? 'Yeni Yetkili Kişi' : 'Yetkili Kişi Düzenle'}
            </h3>
            <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label>T.C. Kimlik No</label>
                <input value={yetkiliModal.tcno || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, tcno: e.target.value.replace(/\D/g,'').slice(0,11) })} maxLength={11} inputMode="numeric" placeholder="11 haneli TC no" />
              </div>
              <div className="form-group">
                <label>Adı *</label>
                <input autoFocus value={yetkiliModal.adi || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, adi: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Soyadı *</label>
                <input value={yetkiliModal.soyadi || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, soyadi: e.target.value })} required />
              </div>
              <div className="form-group">
                <label>Baba Adı</label>
                <input value={yetkiliModal.babadi || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, babadi: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Ana Adı</label>
                <input value={yetkiliModal.anadi || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, anadi: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Doğum Tarihi</label>
                <input type="date" value={yetkiliModal.dogum_tarihi || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, dogum_tarihi: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Doğum Yeri</label>
                <input value={yetkiliModal.dogum_yeri || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, dogum_yeri: e.target.value })} />
              </div>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label>Görevi / Unvanı</label>
                <input value={yetkiliModal.gorevi || ''} onChange={e => setYetkiliModal({ ...yetkiliModal, gorevi: e.target.value })} placeholder="Müdür, Yetkili, vb." />
              </div>
            </div>
            <div className="form-modal-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setYetkiliModal(null)}>İptal</button>
              <button type="button" className="btn btn-primary" onClick={() => {
                if (!(yetkiliModal.adi || '').trim() || !(yetkiliModal.soyadi || '').trim()) { alert('Ad ve Soyad zorunludur.'); return; }
                const { idx, ...kisi } = yetkiliModal;
                if (idx === -1) {
                  setYetkililer(prev => [...prev, kisi]);
                } else {
                  setYetkililer(prev => prev.map((y, i) => i === idx ? kisi : y));
                }
                setYetkiliModal(null);
              }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="card">
          <div className="card-header"><span className="card-title">Genel Bilgiler</span></div>
          <div className="form-grid">
            <div className="form-group">
              <label>Sicil Tipi *</label>
              <select value={form.sicil_tipi} onChange={f('sicil_tipi')} required>
                <option value="GERCEK">Gerçek Kişi</option>
                <option value="TUZEL">Tüzel Kişi / Şirket</option>
                <option value="KAMU">Kamu Kurumu</option>
              </select>
            </div>
            {!tuzel && <>
              <div className="form-group">
                <label>Cinsiyet</label>
                <select value={form.cinsiyet} onChange={f('cinsiyet')}>
                  <option value="">Seçin...</option>
                  <option value="ERKEK">Erkek</option>
                  <option value="KADIN">Kadın</option>
                </select>
              </div>
              <div className="form-group"><label>T.C. Kimlik No *</label><input value={form.tcno} onChange={f('tcno')} maxLength={11} inputMode="numeric" required={!form.vn} /></div>
              <div className="form-group"><label>Adı *</label><input value={form.adi} onChange={f('adi')} required={!tuzel} /></div>
              <div className="form-group"><label>Soyadı *</label><input value={form.soyadi} onChange={f('soyadi')} required={!tuzel} /></div>
              <div className="form-group"><label>Baba Adı</label><input value={form.babadi} onChange={f('babadi')} /></div>
              <div className="form-group"><label>Ana Adı</label><input value={form.anadi} onChange={f('anadi')} /></div>
              <div className="form-group"><label>Doğum Yeri</label><input value={form.dogum_yeri} onChange={f('dogum_yeri')} /></div>
              <div className="form-group"><label>Doğum Tarihi</label><input type="date" value={form.dogum_tarihi} onChange={f('dogum_tarihi')} /></div>
              <div className="form-group">
                <label>Milliyet / Vatandaşlık</label>
                <MilliyetSecici
                  value={form.milliyet_id}
                  onChange={v => setForm({ ...form, milliyet_id: v })}
                  milliyetler={milliyetler}
                  onYeni={() => setMilliyetModal({ adi: '' })}
                  onDuzenle={mid => {
                    const m = milliyetler.find(x => String(x.id) === String(mid));
                    if (m) setMilliyetModal({ id: m.id, adi: m.adi });
                  }}
                />
              </div>
            </>}
            {tuzel && <>
              <div className="form-group" style={{ gridColumn: '1/-1' }}>
                <label>Ünvan *</label>
                <input value={form.unvani} onChange={f('unvani')} required={tuzel} placeholder="Şirket / Kurum ünvanı" />
              </div>
              <div className="form-group">
                <label>Şirket Tipi</label>
                <div className="select-with-action">
                  <select value={form.sirket_tipi_id} onChange={f('sirket_tipi_id')}>
                    <option value="">Seçin...</option>
                    {sirketTipleri.filter(s => !['dernek', 'diğer', 'diger'].includes(s.tip_adi.toLocaleLowerCase('tr-TR'))).map(s => <option key={s.id} value={s.id}>{s.tip_adi}</option>)}
                  </select>
                  <button type="button" className="inline-create-button" onClick={() => setSirketTipiModal(true)}>+ Yeni oluştur</button>
                </div>
              </div>
              <div className="form-group"><label>T.C. Sicil No</label><input value={form.tc_sicil_no} onChange={f('tc_sicil_no')} /></div>
            </>}
          </div>
        </div>

        <div className="sicil-compact-sections">
          <div className="card sicil-compact-card sicil-tax-card">
            <div className="card-header"><span className="card-title">Vergi Bilgileri</span></div>
            <div className="sicil-tax-fields">
              <div className="form-group">
                <label>Vergi No</label>
                <input value={form.vn} onChange={handleVnChange} placeholder="10 haneli vergi numarası" maxLength={10} inputMode="numeric" />
              </div>
              <div className="form-group"><label>Vergi Dairesi</label><input value={form.vd} onChange={f('vd')} /></div>
            </div>
          </div>
          <div className="card sicil-compact-card">
            <div className="card-header"><span className="card-title">Eğitim Durumu</span></div>
            <div className="form-group">
              <label>Eğitim durumu <span className="optional-label">(İsteğe bağlı)</span></label>
              <select value={form.egitim_durumu} onChange={f('egitim_durumu')}>
                <option value="">Seçin...</option>
                {['Okuryazar Değil', 'İlkokul', 'Ortaokul', 'Lise', 'Ön Lisans', 'Lisans', 'Yüksek Lisans', 'Doktora'].map(x => <option key={x} value={x}>{x}</option>)}
              </select>
            </div>
          </div>
          <div className="card sicil-compact-card">
            <div className="card-header"><span className="card-title">Kan Grubu</span></div>
            <div className="form-group">
              <label>Kan grubu <span className="optional-label">(İsteğe bağlı)</span></label>
              <select value={form.kan_grubu} onChange={f('kan_grubu')}>
                <option value="">Seçin...</option>
                {['A Rh+', 'A Rh-', 'B Rh+', 'B Rh-', 'AB Rh+', 'AB Rh-', '0 Rh+', '0 Rh-'].map(x => <option key={x} value={x}>{x}</option>)}
              </select>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><span className="card-title">İletişim</span></div>
          <div className="form-grid">
            <div className="form-group">
              <label className="field-label-with-action"><span>Ana Telefon</span><button type="button" className="inline-add-button" onClick={() => setTelefonlar([...telefonlar, { telefon: '', tip: 'cep' }])} aria-label="Ek telefon ekle" title="Ek telefon ekle">+</button></label>
              <PhoneInput value={form.telefon} onChange={v => setForm({ ...form, telefon: v })} />
            </div>
            <div className="form-group">
              <label>Cep Telefonu</label>
              <PhoneInput value={form.cep_telefonu} onChange={v => setForm({ ...form, cep_telefonu: v })} />
            </div>
            <div className="form-group"><label className="field-label-with-action"><span>Ana E-posta</span><button type="button" className="inline-add-button" onClick={() => setEmailler([...emailler, { email: '' }])} aria-label="Ek e-posta ekle" title="Ek e-posta ekle">+</button></label><input type="email" value={form.email} onChange={f('email')} /></div>
          </div>
          {(telefonlar.length > 0 || emailler.length > 0) && (
            <div className="contact-extras-grid">
              {telefonlar.length > 0 && <div><div className="contact-extra-title">Ek telefonlar</div><MultiTelefonlar value={telefonlar} onChange={setTelefonlar} /></div>}
              {emailler.length > 0 && <div><div className="contact-extra-title">Ek e-posta adresleri</div><MultiEmailler value={emailler} onChange={setEmailler} /></div>}
            </div>
          )}
        </div>

        {tuzel && (
          <div className="card">
            <div className="card-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span className="card-title">👥 Yetkili Kişiler</span>
              <button type="button" className="btn btn-sm btn-outline"
                onClick={() => setYetkiliModal({ idx: -1, tcno: '', adi: '', soyadi: '', babadi: '', anadi: '', dogum_tarihi: '', dogum_yeri: '', gorevi: '' })}>
                + Yetkili Ekle
              </button>
            </div>
            {yetkililer.length === 0 ? (
              <p style={{ color: '#999', fontSize: '13px', padding: '12px 0' }}>Henüz yetkili kişi eklenmedi.</p>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ background: '#f5f7ff', borderBottom: '2px solid #e8eaf6' }}>
                      <th style={{ padding: '8px', textAlign: 'left', fontWeight: 600 }}>TC No</th>
                      <th style={{ padding: '8px', textAlign: 'left', fontWeight: 600 }}>Adı Soyadı</th>
                      <th style={{ padding: '8px', textAlign: 'left', fontWeight: 600 }}>Doğum Tarihi</th>
                      <th style={{ padding: '8px', textAlign: 'left', fontWeight: 600 }}>Görevi</th>
                      <th style={{ padding: '8px', width: '80px' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {yetkililer.map((y, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={{ padding: '8px', color: '#555' }}>{y.tcno || '—'}</td>
                        <td style={{ padding: '8px', fontWeight: 500 }}>{y.adi} {y.soyadi}</td>
                        <td style={{ padding: '8px', color: '#555' }}>{y.dogum_tarihi ? new Date(y.dogum_tarihi).toLocaleDateString('tr-TR') : '—'}</td>
                        <td style={{ padding: '8px', color: '#555' }}>{y.gorevi || '—'}</td>
                        <td style={{ padding: '8px', textAlign: 'right' }}>
                          <button type="button" title="Düzenle"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3949ab', marginRight: '6px', fontSize: '15px' }}
                            onClick={() => setYetkiliModal({ idx: i, ...y })}>✎</button>
                          <button type="button" title="Sil"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: '15px' }}
                            onClick={() => setYetkililer(prev => prev.filter((_, j) => j !== i))}>✕</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>İptal</button>
          <button type="submit" className="btn btn-primary" disabled={kaydediliyor}>
            {kaydediliyor ? 'Kaydediliyor...' : (duzenleme ? '💾 Güncelle' : '✅ Kaydet')}
          </button>
        </div>
      </form>
    </div>
  );
}
